(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-home-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-hw-home]')];
    if (scope.matches?.('[data-hw-home]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.hwInitialized) return;
      root.dataset.hwInitialized = 'true';
      const editor = !!window.Shopify?.designMode || root.hasAttribute('data-hw-design-mode');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = root.querySelectorAll('.hw-reveal');
      reveals.forEach(el => el.classList.add('is-visible'));
      const video = root.querySelector('.hw-hero__video');
      const playback = root.querySelector('[data-hw-playback]');
      if (video && playback) {
        video.muted = true;
        video.controls = false;
        playback.hidden = false;
        const sync = () => {
          playback.setAttribute('aria-label', video.paused ? playback.dataset.playLabel : playback.dataset.pauseLabel);
          playback.querySelector('[data-hw-play-icon]').hidden = !video.paused;
          playback.querySelector('[data-hw-pause-icon]').hidden = video.paused;
        };
        playback.addEventListener('click', () => {
          if (video.paused) video.play().catch(sync);
          else video.pause();
        });
        video.addEventListener('play',sync);
        video.addEventListener('pause',sync);
        if (reduce || editor || video.dataset.autoplay === 'false') {
          video.autoplay = false;
          video.pause();
        } else video.play().catch(sync);
        sync();
      }
      if (editor || reduce) return;
      root.querySelectorAll('[data-hw-tilt]').forEach(card => {
        card.addEventListener('pointermove', event => {
          const rect = card.getBoundingClientRect();
          card.style.transform = 'perspective(1000px) rotateX(' + (((event.clientY-rect.top)/rect.height-.5)*-3) + 'deg) rotateY(' + (((event.clientX-rect.left)/rect.width-.5)*3) + 'deg)';
        });
        card.addEventListener('pointerleave',()=>card.style.transform='');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{
    event.target.setAttribute('data-hw-block-selected','');
    event.target.scrollIntoView({block:'center',behavior:'instant'});
  });
  document.addEventListener('shopify:block:deselect',event=>event.target.removeAttribute('data-hw-block-selected'));
})();
  } catch(e) { console.error(e); }
})();

})();
